import React from "react";
import Chart from "chart.js";
import TradingViewWidget, { Themes } from 'react-tradingview-widget';


export default function CardLineChart() {
  
  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-blueGray-700">
        <div className="rounded-t mb-0 px-4 bg-transparent">
          <div className="flex flex-wrap items-center">
            {/* <div className="relative w-full max-w-full flex-grow flex-1">
              <h6 className="uppercase text-blueGray-100 mb-1 text-xs font-semibold">
                Overview
              </h6>
              <h2 className="text-white text-xl font-semibold">Sales value</h2>
            </div> */}
          </div>
        </div>
        <div className="p-4 flex-auto">
          {/* <Chart/> */}
          <div className="relative h-350-px">
            {/* <canvas id="line-chart"></canvas> */}
            <TradingViewWidget
              symbol="NASDAQ:AAPL"
              crypto
              theme={Themes.DARK}
              locale="en"
              autosize
            />
          </div>
        </div>
      </div>
    </>
  );
}
